import { Modal, ModalContent, ModalTitle } from "@ui-kit/Modal/Modal";
import { Text } from "@ui-kit/Text/Text";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

interface AudioTranscriptProps {
  transcript?: string;
  isOpen: boolean;
  onClose: () => void;
}

const AudioTranscript: FunctionComponent<AudioTranscriptProps> = ({
  transcript,
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Modal open={isOpen} onClose={onClose}>
      <ModalTitle>{t("audioPlayer.transcriptTitle")}</ModalTitle>
      <ModalContent>
        <Text variant="fontBodyMedium">{transcript}</Text>
      </ModalContent>
    </Modal>
  );
};

export { AudioTranscript };
